import type { Accommodation } from "@@/shared/acquire/accommodation";
import { isResourceAccommodation } from "@@/shared/acquire/resources/resource-accommodation/resource-accommodation";
import type { ResourceGraph } from "@@/shared/acquire/resources/resource-graph";
import type { ResourceId } from "@@/shared/acquire/resources/resource-id";
import { findGraphInGraph } from "@@/shared/acquire/sessions/flatten-graph";
import type { Resource } from "../resources/resource";

const findInventoryForPickedResource = (
    accommodation: Accommodation,
    productResourceGraphs: ResourceGraph[],
    pickedGroupId: ResourceId,
) => {
    const inventory = accommodation.inventory.find(r => {
        if (r.groupId === pickedGroupId) return true;
        //Find top level resource group for the inventory
        const graph = productResourceGraphs.find(
            p => p.resourceGroup._id === r.groupId,
        );
        if (!graph) return false;

        const exists = findGraphInGraph(graph, pickedGroupId);
        return !!exists;
    });

    return inventory;
};

//Get sub types that are not disabled
const getPickableSubTypes = (resource: Resource) => {
    if (!isResourceAccommodation(resource)) return [];

    if (!resource.accommodationType) return [];
    if (!resource.accommodationType.subTypes) return [];

    const pickableSubTypes = resource.accommodationType.subTypes.filter(
        subType => {
            return !resource.disabledAccommodationSubTypeIds?.includes(
                subType._id,
            );
        },
    );

    return pickableSubTypes;
};

export { findInventoryForPickedResource, getPickableSubTypes };
